import { render, staticRenderFns } from "./BlocoInformacaoPaises.vue?vue&type=template&id=d0c98d94&lang=pug"
import script from "./BlocoInformacaoPaises.vue?vue&type=script&lang=js"
export * from "./BlocoInformacaoPaises.vue?vue&type=script&lang=js"
import style0 from "./BlocoInformacaoPaises.vue?vue&type=style&index=0&id=d0c98d94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports